import Hero from "../../components/Hero";
import About from "../../components/AboutMe";
import Services from "../../components/home/Services";
import FeaturedProjects from "../../components/home/FeaturedProjects";
import WhyMe from "../../components/home/WhyMe";
import ExperiencePreview from "../../components/home/ExperiencePreview";
import Faq from "../../components/home/Faq";
import CallToAction from "../../components/CallToAction";

/**
 * Represents the Landing page component.
 * Hero, about, services, featured work, experience, FAQ and a closing CTA.
 *
 * @component
 */

const Landing = () => (
  <main className="landing">
    <Hero />
    <About />
    <Services />
    <FeaturedProjects />
    <WhyMe />
    <ExperiencePreview />
    <Faq />
    <CallToAction />
  </main>
);

export default Landing;
